<template>
  <div :class="{ 'dark-list-row--clickable': clickable }" class="dark-list-row">
    <div class="dark-list-row__item">
      <img v-if="imgSource" :src="imgSource" class="dark-list-row__image" />
    </div>

    <div class="dark-list-row__item">
      <h4 class="white dark-list-row__text">
        {{ title }}
      </h4>
      <p v-if="description" class="white dark-list-row__text">
        {{ description }}
      </p>
      <p v-if="position" class="p--navigation-detail dark-list-row__text">
        {{ position }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListRow',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: ''
    },
    imgSource: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';
.dark-list-row {
  background-color: $color-grey-blue-dark;
  padding: $margin-small;
  &--clickable {
    cursor: pointer;
    &:hover {
      background-color: $color-grey-blue-darker;
    }
  }
  &__item {
    display: inline-block;
    vertical-align: middle;
  }
  &__image {
    height: $size-button-medium;
    margin-right: $margin-small;
  }
  &__text {
    margin: 0;
  }
}
</style>
